module.exports = {"id":"214436","name":"Paulo Díaz","rating":"72","photo":"./data/images/photos/3/214436.png","club":{"name":"San Lorenzo","logo":"./data/images/clubs/SanLorenzo.png"},"positions":["DD","DC","DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PauloDiaz0.json
// module id = 3400
// module chunks = 0